import { CALL_RECORDS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const callRecordsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCallRecords: build.query({
      query: (params = {}) => ({
        url: CALL_RECORDS.LIST,
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('CallRecord', result),
    }),
    getCallRecordById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: CALL_RECORDS.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: 'CallRecord',
          id: typeof arg === 'object' && arg != null ? arg.id : arg,
        },
      ],
    }),
    createCallRecord: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: CALL_RECORDS.CREATE,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'CallRecord', id: 'LIST' }],
    }),
    updateCallRecord: build.mutation({
      query: ({ id, data: updateData, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: CALL_RECORDS.BY_ID(id),
          method: 'PUT',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'CallRecord', id },
        { type: 'CallRecord', id: 'LIST' },
      ],
    }),
    deleteCallRecord: build.mutation({
      query: (id) => ({ url: CALL_RECORDS.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'CallRecord', id },
        { type: 'CallRecord', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCallRecordsQuery,
  useLazyGetCallRecordsQuery,
  useGetCallRecordByIdQuery,
  useLazyGetCallRecordByIdQuery,
  useCreateCallRecordMutation,
  useUpdateCallRecordMutation,
  useDeleteCallRecordMutation,
} = callRecordsApi;
